var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"d-navigation"}},[_c('logo-white'),_c('render'),_c('b-button',{staticClass:"__round",attrs:{"size":"is-large","icon-left":"sign-out-alt"},on:{"click":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }